import React from 'react';
import { Plus } from 'lucide-react';

export default function PageHeader({ title, subtitle, onAdd, addLabel = "Add New", kpis = [] }) {
  return (
    <>
      <div className="page-header">
        <div className="header-title-area">
          <h1>{title}</h1>
          <p className="subtitle">{subtitle}</p>
        </div>
        {onAdd && (
          <button className="add-btn" onClick={onAdd}>
            <Plus size={18} />
            <span>{addLabel}</span>
          </button>
        )}
      </div>

      {kpis && kpis.length > 0 && (
        <div className="page-kpis">
          {kpis.map((kpi, index) => (
            <div key={index} className="page-kpi-card">
              <div className={`kpi-icon-wrapper ${kpi.color}`}>
                {kpi.icon}
              </div>
              <div className="kpi-info">
                <span className="kpi-label">{kpi.label}</span>
                <span className="kpi-value">{kpi.value}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
